import React from 'react';
import SoundOnAddToCart from '../SoundOnAddToCart';

export default function DynamicSoundOnAddToCart({ blok }) {
  return <SoundOnAddToCart soundUrl={blok.sound.filename} />;
}
